import style from "./tabs.module.scss"
import {hideBadge, setActiveBadge, setActiveTab} from "../../action/page";
import {connect} from "react-redux";
import {useRef} from "react";
import {useOutsideAlerter} from "../../util/util";
import aqiIcon from "../../assets/aqi-icon.png";
function Tabs({styleClass, page, setActiveBadge, hideBadge, setActiveTab}) {
    const badgesRow = useRef(null);
    useOutsideAlerter(badgesRow, hideBadge);


    return (
        <div className={style.container}>
            
            <div className={[style.bageRow, styleClass].join(" ")}>
                <div
                    className={[style.bageItem, page.activeTab === "aqi" ? style.goodFace : style.neutralFace].join(" ")}
                >
                    <div className={style.header} onClick={() => setActiveTab("aqi")}>
                        <div className={style.name}>AQI</div>
                        <div className={[style.icon].join(" ")}>
                            <img src={aqiIcon} alt="AQI"/>
                        </div>
                    </div>
                </div>
            </div>

            <div className={[style.bageRow, styleClass].join(" ")}>
                <div
                    className={[style.bageItem, page.activeTab === "gdacs" ? style.goodFace : style.neutralFace].join(" ")}
                >
                    <div className={style.header} onClick={() => setActiveTab("gdacs")}>
                        <div className={style.name}>GDACS</div>
                        <div className={[style.icon].join(" ")}>
                            <img src={aqiIcon} alt="GDACS"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

const mapStateToProps = state => ({
    page: state.page
});

const mapDispatchToProps = dispatch => ({
    setActiveBadge: data => dispatch(setActiveBadge(data)),
    setActiveTab: data => dispatch(setActiveTab(data)),
    hideBadge: data => dispatch(hideBadge(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Tabs);
